import type {ReactNode} from 'react';
import {useMedia} from 'react-use';

import WorkTimeTrackingBanner from '@/shared/work-time/components/WorkTimeTrackingBanner';
import {cn} from '@/utils/ui';

import CommandsHint from '../CommandsHint';
import FloatingMenu from '../floating-menu/FloatingMenu';
import Copyright from '../footer/Copyright';
import HelpDropdown from '../HelpDropdown';
import IdleTimer from '../IdleTimer';
import type {MenuItemElement} from '../menu/Menu';
import Menu from '../menu/Menu';
import MyAccountDropdown from '../MyAccountDropdown';
import MyWorkDropdown from '../MyWorkDropdown';
import MenuSidebar from '../sidebars/MenuSidebar';
import SheetSidebar from '../sidebars/SheetSidebar';

export type MenuLayoutProps = {
  children: ReactNode;
  menuItems?: MenuItemElement[];
  className?: string;
};

const MenuLayout = ({children, menuItems, className}: MenuLayoutProps) => {
  const isMobile = useMedia('(max-width: 640px)');

  return (
    <div className="flex min-h-full sm:flex-row">
      {!isMobile && (
        <div className="grow-0">
          <MenuSidebar>
            {isSmall => (
              <>{menuItems && <Menu items={menuItems} isSmall={isSmall} />}</>
            )}
          </MenuSidebar>
        </div>
      )}
      <div className="flex min-w-0 grow flex-col max-sm:pb-28">
        <header className="flex grow-0 flex-row items-center gap-2 p-5 max-sm:gap-1 max-sm:p-3">
          {!isMobile && <CommandsHint />}
          <div className="min-w-0 grow">
            {isMobile && (
              <SheetSidebar>
                {menuItems && <Menu items={menuItems} />}
              </SheetSidebar>
            )}
          </div>
          <IdleTimer />
          <MyWorkDropdown />
          <MyAccountDropdown />
          <HelpDropdown />
        </header>
        <WorkTimeTrackingBanner />
        <main className="grow">
          <div className={cn('p-5', className)}>{children}</div>
        </main>
        <footer className="grow-0">
          <Copyright />
        </footer>
      </div>
      <FloatingMenu />
    </div>
  );
};

export default MenuLayout;
